import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAnalytics} from "firebase/analytics";
import { getPerformance } from "firebase/performance";


const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};


const app = initializeApp(firebaseConfig);
export const analytics =
  typeof window !== "undefined" ? getAnalytics(app) : null;
export const db = getFirestore(app);

export const perf = getPerformance(app);

/**
 * Utility function to log analytics events.
 * @param {string} eventName 
 * @param {object} eventParams 
 */
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    import("firebase/analytics").then(({ logEvent }) => {
      logEvent(analytics, eventName, eventParams);
    });
  }
};